module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-select-field lcs ';
 if (state.disabled) { 
__p+=' is-disabled ';
 } 
__p+=' ';
 if (state.open) { 
__p+=' is-open ';
 } 
__p+='">\n    <div class="lcs__field js-lcs-field">\n        ';
 if (!community || !community.id) { 
__p+='\n            <div class="lcs__placeholder">\n                Please select a community …\n            </div>\n        ';
 } 
__p+='\n    </div>\n</div>\n';
}
return __p;
};
